import { render } from "./FileOptions.vue?vue&type=template&id=9d576992&scoped=true"
import script from "./FileOptions.vue?vue&type=script&lang=js"
export * from "./FileOptions.vue?vue&type=script&lang=js"

import "./FileOptions.vue?vue&type=style&index=0&id=9d576992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d576992"]])

export default __exports__